"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clockSpinnerAnimation = exports.antiClockSpinner = void 0;
var _styledComponents = require("styled-components");
const antiClockSpinner = exports.antiClockSpinner = (0, _styledComponents.keyframes)`
0% {
	transform: rotate(360deg);
}
100% {
	transform: rotate(0deg);
}`;
const clockSpinnerAnimation = exports.clockSpinnerAnimation = (0, _styledComponents.keyframes)`
0% {
	transform: rotate(0deg);
}
100% {
	transform: rotate(360deg);
}`;